import React, { useState, KeyboardEvent, useEffect } from 'react'
import { useTranslations } from '@shared/context/useTranslations';
import { IconNames } from '@shared/enums/icons.enums';
import { Icon } from '@shared/components/Molecules/Icon/Icon.component';
import { cn } from '@shared/helpers/classNames.helper';
import S from './CraneSerialSearch.module.scss'
import { useCrane } from '@shared/context/CraneContext';

export const CraneSerialSearch: React.FC = () => {
    const [inputValue, setInputValue] = useState("");
    const [showNotFound, setShowNotFound] = useState(false);
    const { getTranslation } = useTranslations();
    const { setCraneSerial, serialNumber, isCraneMode } = useCrane();

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
        setShowNotFound(false);
    };

    const handleClearInput = () => {
        setInputValue("");
        setShowNotFound(false);
    };

    const goToSearch = () => {
        if (inputValue) {
            setCraneSerial(inputValue.trim());
        }
    };

    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            goToSearch()
        }
    };

    useEffect(() => {
        setInputValue(serialNumber ? serialNumber : "");
        setShowNotFound(serialNumber ? !isCraneMode : false);
    }, [isCraneMode, serialNumber]);

    return (
        <div className={S.craneSearchContainer}>
            <div className={S.craneSearchContent}>
                <h2 className={S.craneSearchTitle}>{getTranslation("craneSerialSearch.title")}</h2>
                <p className={S.craneSearchDescription}>{getTranslation("craneSerialSearch.description")}</p>
            </div>
            <div className={S.craneSearchInputWrapper}>
                <div className={S.craneSearchBox}>
                    <input
                        type="text"
                        className={S.craneSearchInput}
                        placeholder={getTranslation("craneSerialSearch.placeholder")}
                        value={inputValue}
                        tabIndex={2}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                    />

                    <div className={cn(S.notFoundMessage, { [S.notFound]: showNotFound })}>
                        {getTranslation("craneSerialSearch.notFound")}
                    </div>

                    {inputValue === "" ? (
                        <div className={cn(S.icon, S.searchIcon)}>
                            <button tabIndex={3} onClick={goToSearch}>
                                <Icon iconName={IconNames.Search} />
                            </button>
                        </div>
                    ) : (
                        <div className={cn(S.icon, S.closeIcon)}>
                            <button onClick={handleClearInput}>
                                <span className={S.clearText}>{getTranslation("craneSerialSearch.clear")}</span>
                                <Icon iconName={IconNames.Close} />
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default CraneSerialSearch;